import React from 'react';
import { Box } from '@mui/material';
import { StatCard } from '@/components/ui';
import {
  TrendingUp as TrendingUpIcon,
  TrendingDown as TrendingDownIcon,
  AccountBalance as BankIcon,
  Receipt as ReceiptIcon,
} from '@mui/icons-material';

export const SettlementSummaryCards: React.FC<any> = ({ stats = {} }) => {
  return (
    <Box display="grid" gridTemplateColumns="repeat(auto-fit, minmax(280px, 1fr))" gap={3} mb={4}>
      <StatCard
        title="TOTAL RECONCILIATIONS AMOUNT"
        subtitle="Total settled amount"
        value={`₹${stats.settlement_stats?.total_settlement_amount ?? '0'}`}
        trend="up"
        icon={<TrendingUpIcon />}
        color="success"
        size="medium"
      />

      <StatCard
        title="UNSETTLED AMOUNT"
        subtitle="Total unsettled amount"
        value={`₹${stats.settlement_stats?.total_unsettled_amount ?? '0'}`}
        trend="down"
        icon={<TrendingDownIcon />}
        color="warning"
        size="medium"
      />

      <StatCard
        title="PENDING RECONCILIATIONS"
        subtitle="Total pending reconciliations"
        value={stats.settlement_stats?.total_settled_amount ?? '0'}
        trend="neutral"
        icon={<BankIcon />}
        color="info"
        size="medium"
      />

      {/* <StatCard
        title="TOTAL SETTLEMENTS"
        subtitle="All settlements"
        value={stats?.data?.total_settlements ?? '0'}
        trend="up"
        icon={<ReceiptIcon />}
        color="primary"
        size="medium"
      /> */}
    </Box>
  );
};

export default SettlementSummaryCards;
